import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Legal from "./pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Legal type="impressum" />} />
          <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
